enum ProcessEnum {
    CONTRACT_WITHDRAWAL = "CONTRACT_WITHDRAWAL",
    LOGIN = "LOGIN",
    PASSWORD_RENEWAL = "PASSWORD_RENEWAL"
}

export default ProcessEnum;
